// ── Adapter Supabase do IStorageRepository ────────────────────────
// Implementa a porta do módulo Storage usando o Supabase Storage + tabela
// profiles. É a ÚNICA camada que conhece o bucket e as APIs do Supabase.

import { getSupabase } from '@infra/supabase/client';
import type { IStorageRepository, UploadAvatarParams, UploadImageParams } from '@modules/storage';

export const AVATAR_BUCKET = 'avatars';
export const EMPRESA_LOGO_BUCKET = 'empresa-logos';

export class SupabaseStorageRepository implements IStorageRepository {
  uploadImage = async ({ bucket, path, file, contentType }: UploadImageParams): Promise<string> => {
    const supabase = getSupabase();
    if (!supabase) throw new Error('Supabase não configurado.');

    const { error: upErr } = await supabase.storage
      .from(bucket)
      .upload(path, file, {
        upsert: true,
        contentType,
        cacheControl: '3600',
      });
    if (upErr) throw upErr;

    const { data } = supabase.storage.from(bucket).getPublicUrl(path);
    return data?.publicUrl || '';
  };

  uploadAvatar = (params: UploadAvatarParams): Promise<string> =>
    this.uploadImage({ ...params, bucket: AVATAR_BUCKET });

  setProfileAvatar = async (userId: string, url: string): Promise<void> => {
    const supabase = getSupabase();
    if (!supabase) throw new Error('Supabase não configurado.');
    const { error } = await supabase
      .from('profiles')
      .update({ avatar_url: url })
      .eq('id', userId);
    if (error) throw error;
  };

  setEmpresaLogo = async (empresaId: string, url: string | null): Promise<void> => {
    const supabase = getSupabase();
    if (!supabase) throw new Error('Supabase não configurado.');
    const { error } = await supabase
      .from('empresas')
      .update({ logo_url: url })
      .eq('id', empresaId);
    if (error) throw error;
  };
}
